import React, { useState, Fragment } from "react";
import styles from "../resourceMonitoring/ResourceMonitor.module.scss";
import tabsStyles from "../../../components/controls/tabs/TabsStyles.module.scss";
import { Avatar, Tooltip } from "@fluentui/react-components";
import { Navbar, Nav } from "react-bootstrap";
import AssignedTasksCard from "./AssignedTasksCard";
import AssignedProjectCard from "./AssignedProjectCard";

const ResourceDetails = ({
  isLoading,
  userDetails,
  tasks,
  projects,
  isProjects,
  isTasks,
  defaultTab,
}) => {
  const [selectedTab, setSelectedTab] = useState(defaultTab);

  return (
    <Fragment>
      <div className="d-flex align-items-center justify-content-between mb-4 gap-1">
        <div className="d-flex align-items-center">
          <Avatar
            size={48}
            color="colorful"
            name={userDetails.name}
            image={{ src: userDetails.imageUrl }}
          />
          <h5 className="me-6 ms-6">{userDetails.name}</h5>
          <Tooltip
            content={{
              children: `Capacity: ${
                (
                  (userDetails.allocatedCapacity / userDetails.totalCapacity) *
                  100
                )?.toFixed(2) || 0
              }% Utilized`,
              className: styles.Navtooltip,
            }}
            relationship="label"
            withArrow
            positioning="after"
          >
            <div
              className={`${styles.shiftCellDetail} ${
                userDetails.allocatedCapacity > userDetails.totalCapacity
                  ? styles.OverBooked
                  : (userDetails.allocatedCapacity /
                      userDetails.totalCapacity) *
                      100 >
                    0
                  ? styles.OccupiedHours
                  : (userDetails.allocatedCapacity /
                      userDetails.totalCapacity) *
                      100 ===
                    0
                  ? styles.FullyAvailable
                  : ""
              }`}
            >
              <div
                className={`${styles.shiftStatusBar}`}
                style={{
                  width: `${
                    userDetails.allocatedCapacity > userDetails.totalCapacity
                      ? "100"
                      : (userDetails.allocatedCapacity /
                          userDetails.totalCapacity) *
                        100
                  }%`,
                }}
              >
                <div className={styles.shiftCell_content}>
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex gap-1 w-full">
                      <p className="text-sm-600">
                        {userDetails.allocatedCapacity} /{" "}
                        {userDetails.totalCapacity} hrs
                      </p>
                      <div
                        className={`${styles.shiftCell_bottom} d-flex align-items-center gap-2`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tooltip>
        </div>
        {/* <div className={styles.cardHeader}>
          <span className="text-sm-400 greyStrokeColor">{title}</span>
          <span className={styles.dateRange}>{label}</span>
        </div> */}
      </div>
      <div className="overviewTabsContainer mt-3 mb-4">
        <Navbar
          className={tabsStyles.overviewTabWrapper}
          style={{ boxShadow: "none" }}
        >
          <Nav className={`${tabsStyles.overviewTabItemsWrap} nav-underline`}>
            {isProjects && (
              <Nav.Link
                className={`${tabsStyles.overviewTabItem} ${
                  selectedTab === "projects" && tabsStyles.active
                }`}
                onClick={() => setSelectedTab("projects")}
              >
                Assigned Projects
              </Nav.Link>
            )}
            {isTasks && (
              <Nav.Link
                className={`${tabsStyles.overviewTabItem} ${
                  selectedTab === "tasks" && tabsStyles.active
                }`}
                onClick={() => setSelectedTab("tasks")}
              >
                Assigned Tasks
              </Nav.Link>
            )}
          </Nav>
        </Navbar>
      </div>

      <div className={styles.ShiftDetailsTabContent}>
        {selectedTab === "tasks" ? (
          <AssignedTasksCard isLoading={isLoading} tasks={tasks} />
        ) : selectedTab === "projects" ? (
          <AssignedProjectCard isLoading={isLoading} projects={projects} />
        ) : null}
      </div>
    </Fragment>
  );
};

export default ResourceDetails;
